/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';

import type { ComponentLike } from '@glint/template';
import type { HdsDropdownListItemCheckmarkSignature } from '@hashicorp/design-system-components/components/hds/dropdown/list-item/checkmark';
import type { FilterConfig } from '../../filter-bar';

export interface FilterBarSortCheckmarkSignature {
  Args: {
    checkmark: ComponentLike<HdsDropdownListItemCheckmarkSignature>;
    config: FilterConfig;
    value: string;
    name: string;
    onSortChange: (value: string, text: string) => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLAnchorElement | HTMLButtonElement;
}

export default class FilterBarSortCheckmark extends Component<FilterBarSortCheckmarkSignature> {
  get isSelected(): boolean {
    return this.args.config?.sort?.value === this.args.value;
  }

  <template>
    {{#let @checkmark as |Checkmark|}}
      <Checkmark
        @selected={{this.isSelected}}
        {{on "click" (fn @onSortChange @value @name)}}
        ...attributes
      >
        {{#if (has-block)}}
          {{yield}}
        {{else}}
          {{@name}}
        {{/if}}
      </Checkmark>
    {{/let}}
  </template>
}
